import React from 'react';
import { Link } from 'react-router-dom';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { FiArrowUpRight } from 'react-icons/fi';
import { formatPrice } from '~/utils/format';
import { KrEye, KrEyeSlash } from '~/components/KoroIcons';
import { Transfer } from './styles';

interface ITransferCardProps {
  showValues: boolean;
  setShowValues: (val: boolean) => void;
  total: number;
  available: number;
  drawn: number;
  retained: number;
  cancelled: number;
  optionsTransfer: ApexOptions;
  seriesTransfer: number[];
  donutChart: number;
}

const TransferCard: React.FC<ITransferCardProps> = ({
  showValues,
  setShowValues,
  total,
  available,
  drawn,
  retained,
  cancelled,
  optionsTransfer,
  seriesTransfer,
  donutChart,
}) => {
  return (
    <Transfer className="col-12 bg-white mt-3">
      <div className="row">
        <div className="zoom col-12 d-flex align-items-center justify-content-between pt-3 px-3">
          <h2 className="h3 fw-semibold mb-0">Repasse</h2>
          <Link to={`${process.env.PUBLIC_URL}/financeiro`}>
            <FiArrowUpRight size={24} color="#8c8c8c" />
          </Link>
        </div>
        <div className="col-12 px-3">
          <hr />
        </div>
        <div className="col-lg-6 px-3 d-flex align-items-center justify-content-center">
          <ReactApexChart
            options={optionsTransfer}
            series={seriesTransfer}
            type="donut"
            width={donutChart}
            height={donutChart}
          />
        </div>
        <div className="zoom col-lg-6 px-3 values">
          <p className="h6 fw-normal ">
            <span className="">Total arrecadado</span>
          </p>
          <p className="h2 mb-4 d-flex align-items-center">
            <span>{showValues ? formatPrice(total) : 'R$ -'}</span>
            <button
              type="button"
              onClick={() => setShowValues(!showValues)}
              className="border-0 bg-transparent ms-2"
            >
              {showValues ? (
                <KrEye size={24} color="#FFB580" />
              ) : (
                <KrEyeSlash size={24} color="#FFB580" />
              )}
            </button>
          </p>
          <p className="h6 fw-normal text-white">
            <span className="px-3 py-1">Disponível para saque</span>
          </p>
          <p className="h4 mb-4 d-flex align-items-center">
            <span>{showValues ? formatPrice(available) : 'R$ -'} </span>
          </p>
          <p className="h6 fw-normal text-white">
            <span className="px-3 py-1">Retido</span>
          </p>
          <p className="h4 mb-4">
            {showValues ? formatPrice(retained) : 'R$ -'}
          </p>
          <p className="h6 fw-normal text-white">
            <span className="px-3 py-1">Sacado</span>
          </p>
          <p className="h4 mb-4">{showValues ? formatPrice(drawn) : 'R$ -'}</p>
          <p className="h6 fw-normal text-white">
            <span className="px-3 py-1">Cancelados</span>
          </p>
          <p className="h4 mb-4">
            {showValues ? formatPrice(cancelled) : 'R$ -'}
          </p>
        </div>
      </div>
    </Transfer>
  );
};

export default TransferCard;
